import axios from 'axios';

export async function getBonknames() {
  try {
    const res = await axios.get(`https://bonk.charge.re/clientlist/`, {
      withCredentials: true
    });
    return res.data['response'];
  } catch (e) {
    alert(e.toString());
  }
}

export async function startBonk(name) {
  try {
    const res = await axios.get(`https://bonk.charge.re/request/${name}/`, {
      withCredentials: true
    });
    return Number(res.data['port']); // port
  } catch (e) {
    alert(e.toString());
  }
}

export function routeToBonk(name) {
  if (name === undefined) throw Error("Tried calling Bonk with an undefined name");
  window.open(`/manualbonk/${name}/`, '_blank');
}
